module.exports = __webpack_public_path__ + "static/media/grid.45d5ba1b.png";